import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { CampaignBuilderPage } from './pages/CampaignBuilderPage';
import { DashboardPage } from './pages/DashboardPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminQueuePage } from './pages/AdminQueuePage';
import { AdminApplicationDetailPage } from './pages/AdminApplicationDetailPage';
import { AdminCampaignReviewPage } from './pages/AdminCampaignReviewPage';
import { AdminCampaignsListPage } from './pages/AdminCampaignsListPage';
import { AdminDealsPage } from './pages/AdminDealsPage';
import { ProposalSharePage } from './pages/ProposalSharePage';
import { PartnerLoginPage } from './pages/PartnerLoginPage';
import { PartnerCampaignsPage } from './pages/PartnerCampaignsPage';
import { PartnerCampaignTrackPage } from './pages/PartnerCampaignTrackPage';
import { RequireStaff } from './components/RequireStaff';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* Anchor routes (#sponsor-a-prize) keep onboarding on the same page;
            sponsor-a-prize also resolves so deep links don't 404. */}
        <Route path="/sponsor-a-prize" element={<LandingPage />} />
        {/* Self-serve campaign builder (epic-10). Partner-facing in intent;
            gated server-side until v1-2-6 partner auth lands. */}
        <Route path="/build" element={<CampaignBuilderPage />} />
        {/* Partner campaign dashboard (epic-6). Auth-gated in intent (v1-2-6
            partner-scoped auth deferral); not a public/crawlable route. */}
        <Route path="/dashboard/:campaignId" element={<DashboardPage />} />
        {/* Internal admin console (v1-2-5). Staff-gated client-side (RequireStaff)
            AND server-side (real staff JWT). NOT in the sitemap / not crawlable. */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin"
          element={
            <RequireStaff>
              <AdminQueuePage />
            </RequireStaff>
          }
        />
        <Route
          path="/admin/applications/:id"
          element={
            <RequireStaff>
              <AdminApplicationDetailPage />
            </RequireStaff>
          }
        />
        <Route
          path="/admin/campaigns"
          element={
            <RequireStaff>
              <AdminCampaignsListPage />
            </RequireStaff>
          }
        />
        <Route
          path="/admin/campaigns/:id"
          element={
            <RequireStaff>
              <AdminCampaignReviewPage />
            </RequireStaff>
          }
        />
        {/* Deal workspace & creative library (v2-1). Staff-gated client + server. */}
        <Route
          path="/admin/deals"
          element={
            <RequireStaff>
              <AdminDealsPage />
            </RequireStaff>
          }
        />
        {/* Partner (corporate) portal — separate partner JWT session. Partners
            log in to track THEIR campaigns (funnel + QR + tracking links). */}
        <Route path="/partner/login" element={<PartnerLoginPage />} />
        <Route path="/partner" element={<PartnerCampaignsPage />} />
        <Route path="/partner/campaigns/:id" element={<PartnerCampaignTrackPage />} />
        {/* Public PRIVATE-link-only proposal share page (v2-1). NO login. The
            unguessable token is the only access control; NOT in the sitemap. */}
        <Route path="/p/:token" element={<ProposalSharePage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
